import { useIntl } from 'react-intl';
import { foundation } from '../../../ui';
import MfaOtpRow from './MfaOtpRow';
import { mfaStepTitle, mfaStepSubStyle } from './mfaStyles';

const f = foundation;
const fc = f.color;

const subStyle = { ...mfaStepSubStyle, margin: `0 0 ${f.spacePx[1]}` };
const noteStyle = { margin: `0 0 ${f.spacePx[5]}`, fontSize: f.fontSize.xs, color: fc.neutral.textMuted, fontFamily: f.fontFamily.sans, lineHeight: 1.5, textAlign: 'left' };
// Sideways (KAN-1012): the note -> code gap tightens 20 -> 12 like the other code steps' subtitle.
const sidewaysNoteStyle = { ...noteStyle, margin: `0 0 ${f.spacePx[3]}` };
const messageStyle = { minHeight: 22, textAlign: 'center', fontSize: f.fontSize.sm, fontFamily: f.fontFamily.sans, marginTop: f.spacePx[2], color: fc.semantic.danger, fontWeight: f.fontWeight.medium };

/**
 * RD-SEC-015 flow E — a half-finished enrollment reloaded in a new session
 * (typically an iOS PWA reload mid-handoff, flow G). There's no QR/key left
 * to re-show, so this asks for the code directly and offers an honest
 * "Empezar de nuevo" (unenrolls the stranded factor, back to the intro).
 *
 * RD-SEC-015 (2026-09-25 anatomy fix): the "Verify" + "Start over" CTAs now
 * live in the caller's PINNED footer, not inline here (`onVerify` stays —
 * fires on Enter and, since RD-SEC-019, when a WHOLE code arrives at once
 * (paste / autofill); typing never auto-submits).
 */
export default function MfaStepResume({ code, onChange, status, busy, onVerify, sideways = false }) {
  const intl = useIntl();
  const showError = status === 'error';

  return (
    <div>
      <p style={mfaStepTitle(sideways)}>{intl.formatMessage({ id: 'mfaStepper.resume.title', defaultMessage: 'Finish setting up' })}</p>
      <p style={subStyle}>{intl.formatMessage({ id: 'mfaStepper.resume.sub', defaultMessage: 'Already added CrewVex? Enter the code.' })}</p>
      <p style={sideways ? sidewaysNoteStyle : noteStyle}>{intl.formatMessage({ id: 'mfaStepper.resume.note', defaultMessage: 'If not, start over. The key can’t be shown again.' })}</p>
      <MfaOtpRow
        sideways={sideways}
        value={code}
        onChange={onChange}
        disabled={busy}
        status={status}
        onSubmit={(digits) => onVerify(digits)}
        onWholeCode={(digits) => onVerify(digits)}
        groupLabel={intl.formatMessage({ id: 'mfaStepper.resume.title', defaultMessage: 'Finish setting up' })}
        digitLabel={(n) => intl.formatMessage({ id: 'auth.digitAria', defaultMessage: 'Digit {n} of 6' }, { n })}
      />
      {showError ? (
        <div style={messageStyle}>{intl.formatMessage({ id: 'mfaStepper.code.err1', defaultMessage: 'That code doesn’t match. Use the current one.' })}</div>
      ) : <div style={{ minHeight: 22 }} />}
    </div>
  );
}
